import { Fragment, useCallback, type FC, type PropsWithChildren } from 'react';

import { MainPageHeader } from '#packages/web/layouts/page/header';
import {
  PageContent,
  type PageContentProps,
} from '#packages/web/layouts/page/page-content';

import { useDrawer } from '../hooks/use-drawer';
import { PageErrorBoundary } from './page-error-boundary';

export type MainPageLayoutProps = {
  /**
   * Title to display at the top of the page.
   */
  title: string;

  /**
   * Props to pass to the PageContent component.
   */
  pageContentProps?: Partial<PageContentProps>;

  /**
   *
   */
  onErrorActionClick?: () => void;
};

export const MainPageLayout: FC<PropsWithChildren<MainPageLayoutProps>> = ({
  title,

  pageContentProps,
  onErrorActionClick = useCallback(() => window.location.reload(), []),

  children,
}) => {
  const drawer = useDrawer();

  return (
    <Fragment>
      <MainPageHeader title={title} onNavigationIconClick={drawer.open} />
      <PageContent {...pageContentProps}>
        <PageErrorBoundary onActionClick={onErrorActionClick}>
          {children}
        </PageErrorBoundary>
      </PageContent>
    </Fragment>
  );
};
